import { Customization } from '../models/customization'

export const buildStepContainerStyles = (customization: Customization) => {
    try {
        const {
            scheduling_modal: {
                background_color_style,
                colors: { background_color_1, background_color_2, text },
            },
        } = customization

        const backgroundColor =
            background_color_style === 'gradient'
                ? `--body-gradient: linear-gradient(329deg, ${background_color_1} 0%, ${background_color_2} 100%);`
                : `--body-gradient: ${background_color_1};`

        const textColor = `--body-color: ${text};`

        return `
            :root {
                ${backgroundColor}
                ${textColor}
            }
        `
    } catch (err) {
        return ''
    }
}
